import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import useAuthCheck from "../hooks/useAuthCheck";
import { ReactComponent as LogoIcon } from "../assets/Logo.svg";
import { getFromLocalStorage } from "../utils/localStorageUtil";

const AdminProtectedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = useAuthCheck();
  const [isNotaryAdmin, setIsNotaryAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    if (isLoggedIn === false) {
      navigate("/login");
    }
    const roles = getFromLocalStorage("roles");
    // UI affordance only, not access control: localStorage is user-editable.
    // Real enforcement for the video-provider write path is server-side via
    // hasRole(official, ROLE_INTERNAL_STAFF) in api/handlers/videoProvider/update.js.
    // notaryAdmin is kept here so /impersonation (which only checks notaryAdmin)
    // keeps working unchanged; internalStaff is the role the API actually enforces.
    if (roles?.includes("notaryAdmin") || roles?.includes("internalStaff")) {
      setIsNotaryAdmin(true);
    } else {
      setIsNotaryAdmin(false);
    }
  }, [isLoggedIn, navigate]);

  if (isLoggedIn === null || isNotaryAdmin === null) {
    return <Logo><LogoIcon /></Logo>;
  }

  if (!isNotaryAdmin) {
    return <PermissionDenied>You do not have permission to view this page.</PermissionDenied>;
  }

  return (
    <>
      <Header />
      <MainContent>{children}</MainContent>
    </>
  );
};

export default AdminProtectedLayout;

const MainContent = styled.div`
  position: relative;
  display: flex;
  width: 94%;
  left: 6%;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

const PermissionDenied = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  font-size: 20px;
  color: red;
  font-weight: bold;
`;
